class PromoCodeBanners extends HTMLElement {
    constructor() {
        super();
        // console.log('promo-code-banners init');
        this.shopDomain = this.dataset.shopDomain;

    }

    connectedCallback() {
        this.imgElementDesktop = this.querySelector('#promo-code-banner-desktop');
        this.imgElementMobile = this.querySelector('#promo-code-banner-mobile');

       messenger.listen(messenger.topics.PROMOCODE_CAPTURED, (data) => {
            this.setPromocodeBanner(data);
        })

        this.setPromocodeBanner();
    }

    setPromocodeBanner(data = null) {
        const promoCode = data ? data : knocking.getCookie('promo_code');
        if (!promoCode) {
            console.log('no promo code, not setting banner');
            return;
        }
        const json = this.querySelector('script[type="application/json"]');
        if (!json) {
            console.log('no json, not setting banner');
            return;
        }
        const promoCodeBannerMap = JSON.parse(json.textContent);
        if (promoCodeBannerMap[promoCode]) {
            const bannerFileName = promoCodeBannerMap[promoCode];
            this.imgElementDesktop.src = `http://${this.shopDomain}/cdn/shop/files/${bannerFileName}-desktop.png`;
            this.imgElementMobile.src = `http://${this.shopDomain}/cdn/shop/files/${bannerFileName}-mobile.png`;
        }
    }
}

customElements.define('promo-code-banners', PromoCodeBanners);
